import {store} from "@/store/store";

export function ExclusiveCoordinateManager (viewManager, registrationNumber) {
	this.pollTimer = null;
	this.exclusiveTimer = null;
	this.registrationNumber = registrationNumber;
	this.$rest = null;
	this.viewManager = viewManager;

	this.startPolling = ($rest) => {
		this.$rest = $rest;
		this.pollTimer = setInterval(async () => {
			const resp = await this.$rest.getExclusive(this.registrationNumber);
			console.log("resp", resp)
			if(!resp) return;
			const lastExclusive = store.getters.getExclusiveCoordinates[store.getters.getExclusiveCoordinates.length - 1];
			console.log("lastExclusive", lastExclusive)
			const lastTime = lastExclusive ? new Date(lastExclusive.time).getTime() : 0;
			const respTime = new Date(resp.time).getTime();
			console.log("lastTime", lastTime, "respTime", respTime);
			if(lastTime >= respTime) return; //THIS is already received

			let routeId = window.consentedStorage.getItem('currentRouteIdWithUuid');
			if(!routeId) return // No routeId
			console.log("Received routeId", routeId);
			routeId = routeId.split('-')[0];
			if(store.getters.getExclusiveCoordinate) // to not draw a big line
				this.viewManager.updateExclusiveCoordinate(routeId, resp);
			await store.dispatch("storeExclusiveCoordinate", true)
			await store.dispatch("addExclusiveCoordinate", {
				...resp,
				receivedAt: new Date().toISOString(),
				delay: new Date().getTime() - new Date(resp.time).getTime()
			});

			const c = resp;
			await store.dispatch('storeCurrentGPS', {
				lat: c.lat,
				lng: c.lng,
				alt: c.alt * 0.3048,
				course: c.track,
				speed: c.speed,
				time: c.time
			});
			if(this.exclusiveTimer) {
				clearTimeout(this.exclusiveTimer);
				this.exclusiveTimer = null;
			}
			this.exclusiveTimer = setTimeout(() => {
				store.dispatch("storeExclusiveCoordinate", false)
			}, 10000);
		}, 3000);
	}

	this.stopPolling = () => {
		if(this.pollTimer) {
			clearTimeout(this.pollTimer);
		}
		if(this.exclusiveTimer) {
			clearTimeout(this.exclusiveTimer);
		}
	}
}
